import { STATIC_DATASET_USAGE_KEY } from '@/utils/queryKeys.ts';
import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import {
  AUTOMATION_LATEST_VERSION_KEY,
  AUTOMATION_VERSION_KEY,
  AUTOMATION_VERSIONS_KEY,
} from '@/utils/queryKeys.ts';
import { AutomationVersion } from '@/types/automations.ts';

const useInvalidateAutomationVersion = (automationId: string) => {
  const queryClient = useQueryClient();

  return useCallback(
    (version: AutomationVersion): unknown[][] => {
      queryClient.setQueryData<AutomationVersion>(
        AUTOMATION_VERSION_KEY(automationId, version.id),
        version,
      );
      return [
        AUTOMATION_VERSIONS_KEY(automationId),
        AUTOMATION_LATEST_VERSION_KEY(automationId),
        STATIC_DATASET_USAGE_KEY(automationId),
      ];
    },
    [automationId, queryClient],
  );
};

export default useInvalidateAutomationVersion;
